import { useState, useEffect } from "react";
import axios from "axios";
import { logError } from "@/lib/logger";
import { getAuthHeaders } from "@/lib/adminAuth";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function InquiryCard({ inq }) {
  return (
    <div className="bg-white border border-border p-5">
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="font-sans font-medium text-sm text-foreground">{inq.name}</h3>
          <p className="text-xs font-sans text-muted-foreground">{inq.company_name} &middot; {inq.country}</p>
        </div>
        <span className={`text-[10px] font-sans uppercase tracking-wider px-2 py-0.5 ${
          inq.status === "new" ? "text-blue-600 bg-blue-50" : "text-green-600 bg-green-50"
        }`}>{inq.status}</span>
      </div>
      <p className="text-sm font-sans text-foreground/80 mb-2">{inq.inquiry_details}</p>
      <div className="flex gap-4 text-xs font-sans text-muted-foreground">
        <span>{inq.email}</span>
        <span>{inq.phone}</span>
        <span>{new Date(inq.created_at).toLocaleString()}</span>
      </div>
    </div>
  );
}

export const InquiriesManagement = () => {
  const [inquiries, setInquiries] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/inquiries`, { headers: getAuthHeaders() });
        setInquiries(res.data);
      } catch (err) {
        logError("Failed to fetch inquiries", err);
      }
    })();
  }, []);

  return (
    <div data-testid="admin-inquiries">
      <h1 className="text-3xl font-serif text-foreground mb-8">Inquiries</h1>
      <div className="space-y-3">
        {inquiries.map((inq) => <InquiryCard key={inq.id} inq={inq} />)}
        {inquiries.length === 0 && <p className="text-sm font-sans text-muted-foreground text-center py-12">No inquiries yet.</p>}
      </div>
    </div>
  );
};
